/** Product surfaces hidden until their implementation is ready for customers. */
export const productFeatures = {
  sales: false,
  loyalty: false,
  appDownload: false,
};
